import {
  MessageSquare,
  PlusCircle,
  FolderKanban,
  Bot,
  Users,
  Wrench,
  Workflow,
  ListTodo,
  BarChart3,
} from 'lucide-react';

/** Primary sidebar nav — Chrono routes only. */
export const NavData = [
  {
    path: 'chat',
    file: 'new-chat',
    name: 'Walt Chat',
    icon: MessageSquare,
    haskey: true,
  },
  {
    path: 'create-agent',
    file: 'create-agent',
    name: 'Create Agent',
    icon: PlusCircle,
    haskey: true,
  },
  {
    path: 'projects',
    file: 'projects',
    name: 'Projects',
    icon: FolderKanban,
  },
  {
    path: 'agents',
    file: 'agents',
    name: 'Agents',
    icon: Bot,
  },
  {
    path: 'team',
    file: 'team',
    name: 'Team',
    icon: Users,
  },
  {
    path: 'tools',
    file: 'tools',
    name: 'Tools',
    icon: Wrench,
  },
  {
    path: 'workflows',
    file: 'create-workflow',
    name: 'Workflows',
    icon: Workflow,
  },
  {
    path: 'task-manager',
    file: 'task-manager',
    name: 'Task Manager',
    icon: ListTodo,
  },
];

export const SecondaryNavData = [
  { path: 'analytics', name: 'Analytics', icon: BarChart3 },
];
